import type { Derivacion } from '@/lib/cuadro/agregaciones';
import { textoEscaladas } from '@/lib/cuadro/filtros';
import { Icono } from '../Layout/iconos';

// A quién se escala (prototipo: derivs). 3 destinos fijos.

const ICONO_DESTINO: Record<Derivacion['destino'], string> = {
  operaciones: 'wrench',
  comercial: 'users',
  otros: 'escalate',
};

// colores por destino como el prototipo (hbar): naranja / navy / gris
const COLOR_DESTINO: Record<Derivacion['destino'], string> = {
  operaciones: 'var(--orange)',
  comercial: 'var(--navy)',
  otros: 'var(--text-mute)',
};

export function Derivaciones({
  derivaciones,
  hayFiltros,
}: {
  derivaciones: Derivacion[];
  hayFiltros: boolean;
}) {
  const totalEscaladas = derivaciones.reduce((a, d) => a + d.total, 0);
  const mayor = Math.max(...derivaciones.map((d) => d.total), 1);
  return (
    <ul className="m-0 list-none space-y-2.5 p-0">
      {derivaciones.map((d) => (
        <li key={d.destino} className="text-[12.5px]">
          <div className="mb-1 flex items-center gap-2.5">
            <span className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-[var(--status-esc-bg)] text-[var(--status-esc-ink)]">
              <Icono nombre={ICONO_DESTINO[d.destino]} className="h-3.5 w-3.5" />
            </span>
            <span className="min-w-0 flex-1 truncate text-[var(--text-2)]">{d.etiqueta}</span>
            <span className="mono font-semibold text-[var(--navy)]">{d.total}</span>
          </div>
          <div className="ml-[38px] h-1.5 overflow-hidden rounded-full bg-[var(--surface-3)]">
            <div
              className="h-full rounded-full opacity-85"
              style={{
                width: `${(d.total / mayor) * 100}%`,
                background: COLOR_DESTINO[d.destino],
              }}
            />
          </div>
        </li>
      ))}
      <li
        data-testid="derivaciones-total"
        className="border-t border-[var(--border-soft)] pt-2 text-[11.5px] text-[var(--text-dim)]"
      >
        {textoEscaladas(totalEscaladas, hayFiltros)}.
      </li>
    </ul>
  );
}
